<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <div class="bd-example">
            <dl class="row">
              <dt class="col-sm-3">{{ $t('page.generic.code') }}</dt>
              <dd class="col-sm-9">{{categoriesData.code}}</dd>
              <dt class="col-sm-3">{{ $t('page.generic.name') }}</dt>
              <dd class="col-sm-9">{{categoriesData.label}}</dd>
              <dt class="col-sm-3">{{ $t('page.generic.description') }}</dt>
              <dd class="col-sm-9">{{ categoriesData.description }}</dd>
            </dl>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <button class="btn btn-danger float-right padder" variant="danger" @click="deleteModal = true"
                      type="button">
                {{ $t('actions.delete') }}
              </button>
              <router-link v-if="categoriesData.id" class="btn btn-primary float-right" role="button"
                           :to="{name: 'categoryEditRoute', params: {id:categoriesData.id}}">
                {{ $t('actions.edit') }}
              </router-link>
              <!-- Modal Component -->
              <b-modal title="Eliminazione categoria" class="modal-danger" v-model="deleteModal" @ok="deleteCategory"
                       ok-variant="danger">
                {{ $t('page.generic.deleteMessage', {n: categoriesData.code}) }}
              </b-modal>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import miniToastr from 'mini-toastr' //ES6
  import PageTitle from '@/components/PageTitle'
  import CategoryService from '@/services/CategoryService'

  const categoryService = CategoryService.build();

  export default {
    name: 'categoryShow',
    props: {
      id: {
        required: true
      }
    },
    components: {
      PageTitle
    },
    data() {
      return {
        deleteModal: false,
        categoriesData: {}
      }
    },
    created() {
      miniToastr.init(); // config can be passed here miniToastr.init(config)
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
      this.fetchData()
    },
    methods: {
      async fetchData() {
        this.categoriesData = await categoryService.read(this.id)
      },
      async deleteCategory() {
        try {
          await categoryService.destroy(this.id);
          this.$router.replace({name: 'categoryRoute'});
          miniToastr.info("Categoria cancellata con successo!")
        } catch (exception) {
          miniToastr.error(exception.message)
        }
      }
    }
  }
</script>
